import React, { Component } from 'react';
import { translate } from 'react-i18next';
import DatabaseService from 'services/DatabaseService.js';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import ga from 'analytics';

import Utils from 'utils/Utils.js';
import {initNavbarState} from 'actions/navbar.js';
import {NavControl} from 'modules/navigation/NavBarContainer'
import {getUserProfileWithDefaults} from 'reducers/user.js';
import {getHistoryWithChallenge} from 'reducers';
import {getChallenges, getPinned} from 'reducers/challenges.js';
import {getUserCategories} from 'reducers/userCategories.js';
import {getCards} from 'reducers/cards.js';
import {skipChallenge} from 'actions/challenges.js';
import {fetchTimeline} from 'actions/timeline.js';
import ChallengeUtils from 'utils/ChallengeUtils.js';
import {areFeaturesLoaded, getFeaturePluginSetting} from 'reducers/features.js';

import Today from './Today.js';
import Challenge from './Challenge.js';
import CompetitionContainer from './CompetitionContainer.js';




class TodayContainer extends Component {
    constructor(props){
        super(props);
        this.state = {busy: false, 
                      selectedChallengeId:null, 
                      selectedCompetition:null,
                      showCompetitionActivities:false,
                      skipCompetitionPage:false};
        this.onCloseChallenge = this.onCloseChallenge.bind(this);
        this.onCloseCompetition = this.onCloseCompetition.bind(this);
        this.onSkipRight = this.onSkipRight.bind(this);
        this.onSkipLeft = this.onSkipLeft.bind(this);
        this.onClickHistory = this.onClickHistory.bind(this);
        this.onLaunchChallenge = this.onLaunchChallenge.bind(this);
        this.onLaunchCompetition = this.onLaunchCompetition.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onLaunchUserChallenge = this.onLaunchUserChallenge.bind(this);
        this.editSubscriptions = this.editSubscriptions.bind(this);
        this.onAddNewGoal = this.onAddNewGoal.bind(this);
        this.onShowCompetitionActivities = this.onShowCompetitionActivities.bind(this);
        this.onLaunchCompetitionActivities = this.onLaunchCompetitionActivities.bind(this);
        this.onHideCompetitionActivities = this.onHideCompetitionActivities.bind(this);
        this.formatDuration = this.formatDuration.bind(this);
        this.formatYellowLabelEndsAt = this.formatYellowLabelEndsAt.bind(this);
        this.getCompetitionYellowLabel = this.getCompetitionYellowLabel.bind(this);
    }

    componentWillMount() {
        this.props.initNavBar(this.props.t);
        this.loadData();
    }

    componentWillReceiveProps(newProps) {
        var oldBadgeNumbers = this.props.badgeNumbers;
        var newBadgeNumbers = newProps.badgeNumbers;
    }

    getSelectedLogCategory(id, categories) {
        if(id!==null && id !==undefined && categories) {
            return categories.filter(c => c.id===Number(id))[0];
        }
        return null;
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData()
        .then(([response, fetchLogCategoriesResponse])=>{
                var logCategories = fetchLogCategoriesResponse.categories;
                var selectedLogCategory = null;
                if(this.props.selectLogCategory) {
                    selectedLogCategory = this.getSelectedLogCategory(this.props.match.params.id, logCategories);
                }
                this.setState({busy:false, numUserCategories : response.summary.categories, logCategories:logCategories, selectedLogCategory});
            })
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            
    }

    onSkipLeft(e, challenge) {
        e.stopPropagation();
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        this.props.skipChallenge(challenge.id, false)
            .catch((error)=>{
                console.error('Error ', error);
            })
            .then(()=>{
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }
    onSkipRight(e, challenge) {
        e.stopPropagation();
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        this.props.skipChallenge(challenge.id, true)
            .catch((error)=>{
                console.error('Error ', error);
            })
            .then(()=>{
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    launchSections(categoryId) {
        this.props.history.push('/sections/'+categoryId);
    }

    onClickHistory(e, categoryId) {
        if(e) {
            e.stopPropagation();
        }
        this.launchSections(categoryId);
    }

    onLaunchChallenge(challenge) {
        Utils.pushScrollPosition();
        this.setState({selectedChallengeId:challenge.id}); 
    }

    onLaunchCompetition(e, competitionCard) {
        if(e) {
            e.stopPropagation();
        }
        Utils.pushScrollPosition();
        this.setState({selectedCompetition:competitionCard}); 
    }

    onNavigate(item) {
        var navigation = item.navigation;
        if(navigation) {
            var route = navigation.route;
            if(route) {
                this.props.history.push(route);
            }
        }
    }

    onLaunchUserChallenge(userchallenge) {
        if(userchallenge && userchallenge.challenge && userchallenge.challenge.category) {
            this.launchSections(userchallenge.challenge.category.id);
        }
    }

    onCloseChallenge() {
        this.setState({selectedChallengeId:null},
            ()=>{
                Utils.popScrollPosition();
            } 
        ); 
        this.props.initNavBar(this.props.t);
        //opening a challenge manually triggers a virtual page because the route has not changed - this tells google-analytics we're back on the page last tracked by urlChangeTracker
        ga('send', 'pageview'); 
    }

    onCloseCompetition() {
        this.setState({selectedCompetition:null, showCompetitionActivities:false, skipCompetitionPage:false},
            ()=>{
                Utils.popScrollPosition();
            } 
        ); 
        this.props.initNavBar(this.props.t);
        //opening a challenge manually triggers a virtual page because the route has not changed - this tells google-analytics we're back on the page last tracked by urlChangeTracker
        ga('send', 'pageview'); 
    }

    onHideCompetitionActivities() {
        this.setState({showCompetitionActivities:false},
            ()=>{
                Utils.popScrollPosition();
            } 
        );
    }

    formatDuration(duration) {
        return ChallengeUtils.formatDuration(this.props.t, duration);
    }

    getChallengeImageUrl(challenge) {
        return ChallengeUtils.getChallengeImageUrl(challenge);
    }


    formatYellowLabelEndsAt(endsAt) {
        var endMoment = moment(endsAt);
        var now = moment();

        var msUntilEnd = endMoment.toDate().getTime() - now.toDate().getTime();
        var timeUntilEndDuration = moment.duration(msUntilEnd);
        if(timeUntilEndDuration.asDays() < 0) {
            return this.props.t('Expired');
        } else if (timeUntilEndDuration.asDays() >= 1) {
            return this.props.t('days-left', {days:Math.round(timeUntilEndDuration.asDays())});
        } else {
            return moment(msUntilEnd).utc().format('HH:mm:ss');
        }
    }

    getCompetitionYellowLabel(competition) {
        var label = [];
        var seasonTitle = Utils.deref(competition, 'season.title');
        if(seasonTitle) {
            label.push(seasonTitle);
        }
        var endsAt = Utils.deref(competition, 'season.endsAt');
        if(endsAt) {
            label.push(this.formatYellowLabelEndsAt(endsAt));
        }
        
        return label.join(' - ');
    }
    
    challengeTypeToName(type) {
        return ChallengeUtils.Types[type];
    }
    
    editSubscriptions() {
        this.props.history.push('/categories');
    }

    onAddNewGoal() {
        this.props.history.push('/objectives');
    }

    getShowSetGoals() {
        var surveys = DatabaseService.getSurveysCache();
        return Boolean(surveys.personality && surveys.personality.id);
    }

    getDimmerChallenge() {
        if(this.state.busy || this.getShowSetGoals()) {
            return null;
        }

        var challenges = this.props.challenges;
        if(challenges && challenges.length>0) {
            var filteredChallenges = challenges.filter(c=>c.category && c.category.tag==='tutorial');
            if(filteredChallenges.length==1) {
                var tutorialChallenge = filteredChallenges[0];
                var dimmerMessage = this.props.t('tutorial_challenge_message_[points]', {points:tutorialChallenge.points});
                return {...tutorialChallenge, dimmerMessage:dimmerMessage};
            }
        }
        return null;
    }

    onShowCompetitionActivities() {
        Utils.pushScrollPosition();
        this.setState({showCompetitionActivities:true, skipCompetitionPage:false},
            () => {
                window.scrollTo(0, 0); 
            }
        );
    }

    onLaunchCompetitionActivities(competition) {
        var userRecord = Utils.deref(competition, 'season.userRecord');
        if(userRecord) {
            Utils.pushScrollPosition();
            this.setState({showCompetitionActivities:true, selectedCompetition: competition, skipCompetitionPage:true});
        } else {
            this.onLaunchCompetition(null, competition);
        }
    }

    render() {
        if(this.state.selectedChallengeId) {
            return (
                <NavControl onClose={this.onCloseChallenge}>
                    <Challenge challengeId={this.state.selectedChallengeId} onContinue={this.onCloseChallenge} />
                </NavControl>
            );
        } else if (this.state.selectedCompetition) {
            return (
                <NavControl onClose={this.state.showCompetitionActivities && !this.state.skipCompetitionPage ? this.onHideCompetitionActivities : this.onCloseCompetition}>
                    <CompetitionContainer card={this.state.selectedCompetition} 
                                          showCompetitionActivities={this.state.showCompetitionActivities} 
                                          onShowCompetitionActivities={this.onShowCompetitionActivities}
                                          onLaunchChallenge={this.onLaunchChallenge} />
                </NavControl>
            );
        } else {
            return (
                <Today cards={this.props.cards}
                       challenges={this.props.challenges}
                       dimmerChallenge={this.getDimmerChallenge()}
                       showSetGoals={this.getShowSetGoals()}
                       userProfile={this.props.userProfile}
                       userRank={this.props.userRank}
                       pinned={this.props.pinned} 
                       timelineHistory={this.props.timelineHistory} 
                       busy={this.state.busy || !this.props.featuresLoaded}
                       editSubscriptions={this.editSubscriptions}
                       logCategories={this.state.logCategories}
                       selectedLogCategory={this.state.selectedLogCategory}
                       onAddNewGoal={(this.props.userLimit === undefined || this.state.numUserCategories < this.props.userLimit) && this.onAddNewGoal}
                       onSkipLeft={this.onSkipLeft}
                       onSkipRight={this.onSkipRight}
                       onClickHistory={this.onClickHistory}
                       onLaunchChallenge={this.onLaunchChallenge}
                       onLaunchCompetition={this.onLaunchCompetition}
                       onLaunchCompetitionActivities={this.onLaunchCompetitionActivities}
                       onNavigate={this.onNavigate}
                       onLaunchUserChallenge={this.onLaunchUserChallenge}
                       formatDuration={this.formatDuration}
                       challengeTypeToName={this.challengeTypeToName}
                       getChallengeImageUrl={this.getChallengeImageUrl}
                       getCompetitionYellowLabel={this.getCompetitionYellowLabel}/>
                );
        }
    }

}


const mapStateToProps = (state) => {
    return {userProfile:getUserProfileWithDefaults(state.user),
            userRank:state.user.rank,
            badgeNumbers:state.user.badgeNumbers,
            cards:getCards(state.cards),
            challenges:getChallenges(state.challenges),
            pinned:getPinned(state.challenges),
            timelineHistory:getHistoryWithChallenge(state),
            featuresLoaded : areFeaturesLoaded(state.features),
            userLimit : getFeaturePluginSetting(state.features, 'categories', 'userLimit'),
           };
};

const mapDispatchToProps = (dispatch) => {
    return {
        initNavBar: (t) => dispatch(initNavbarState({enable:true, title:t('Home'), menuEnable:true, backButtonEnable:false, rewardsEnable:true, mode: 'main'})),
        skipChallenge: (challengeId, forward) => dispatch(skipChallenge(challengeId, forward)),
        loadData: () => { 
            return Promise.all([dispatch(fetchTimeline()),
                                DatabaseService.fetchLogCategories()
                   ]);
        },
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('challenges')(TodayContainer)));



// WEBPACK FOOTER //
// ./src/modules/challenges/TodayContainer.js